import {GET} from 'lib/core/localStorage';

const isAuthenticated = () => {
  const {token} = GET('access-token');
  if (token) return true;
  return false;
};

export default isAuthenticated;
